import { isBoolean } from "presentation/utils/functions/generic";

// Periods methods
// Carrega um item no state
export const loadPeriod = (key, component) => {
    const { periods } = component.state;
    let output = undefined;

    if (periods.length > 0) {
        var item = periods.find(x => { return x.key == key });
        output = item !== undefined ? item : undefined;
    }
    return output;
}

// Monta a lista no state
export const mountPeriodItems = (component) => {

    const { totalPeriodItems, periods } = component.state;

    const deleteRequested = periods.filter(x => x.isDeleteRequested === true);

    let newPeriods = [];

    for (let i = 0; i < totalPeriodItems; i++) {

        let itemKey = i + 1;

        //Default values

        let defaultItemId = null;
        let defaultEvaluationSchemeId = null;
        let defaultName = undefined;

        let period = loadPeriod(itemKey, component);

        let newItem = {
            key: itemKey,
            id: defaultItemId,
            evaluationSchemeId: defaultEvaluationSchemeId,
            name: defaultName
        };

        if (period !== undefined) {
            newItem = { ...period };
        }

        newPeriods.push(newItem);
    }

    let finalPeriods = [...newPeriods, ...deleteRequested];

    component.setState({ periods: finalPeriods });
}

//Carrega as informações de um campo específico do item no state
export const periodsFormValue = (key, formField, component) => {

    let output = undefined;

    var item = loadPeriod(key, component);

    output = item !== undefined ? item[formField] : undefined;

    return output;

}

//Tratativas para quando um campo muda de valor (geral)
export const handleChangePeriods = (key, event, component) => {
    const { value, checked, type } = event.target;

    const name = event.target.getAttribute('data-field-name');
    const isTrueUnique = (event.target.getAttribute('data-field-is-true-unique') === "true");
    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, component, isTrueUnique);
}


//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, component, isTrueUnique = false) => {
    var item = loadPeriod(key, component);

    item = { ...item, [field]: value };

    const newPeriods = changePeriodsList(component, item);

    let finalOptions = beforeChangePeriodsState(key, field, value, newPeriods, component, isTrueUnique);

    component.setState({
        periods: finalOptions
    });
}

//Método para executar tratamentos antes da mudança para o novo state do formulário
export const beforeChangePeriodsState = (key, changedField, changeValue, newPeriods, component, isTrueUnique = false) => {


    let output = newPeriods.map((le, i) => {
        if (!le.id) {
            let tempId = generatePeriodVirtualId();
            le.id = tempId;
            le.tempId = tempId;
            le.isVirtualId = true;
        }
        return le;
    });
    //Apenas um item desse tipo de campo pode ser true
    if (isTrueUnique == true && isBoolean(changeValue) && changeValue === true) {
        output = newPeriods.map((e, i) => {
            if (e.key !== key) {
                e[changedField] = false;
            }
            return e;
        });
    }



    return output;
}

export const generatePeriodVirtualId = () => {
    return `temp-period-${new Date().getTime()}`;
}

//Prapara o objeto do state para a atualização com as informações das alternativas da questão
export const changePeriodsList = (component, targetOption, remove = false) => {
    let { periods } = component.state;

    let optionIndex = periods.findIndex(option => option.key == targetOption.key);

    if (remove === true) {
        let elementId = periods[optionIndex]['id'] || undefined;
        let isVirtualId = periods[optionIndex]['isVirtualId'] || false;

        let isApiDeleteRequired = isVirtualId ? false : (elementId ? true : false);

        if (isApiDeleteRequired) {
            periods[optionIndex]['isDeleteRequested'] = true;
            periods[optionIndex]['key'] = 'delete-requested-' + new Date().getTime();
        } else {
            periods.splice(optionIndex, 1);
        }
    } else {
        periods[optionIndex] = targetOption;
    }

    return periods;
}


const periodsFunctions = {
    loadPeriod,
    periodsFormValue,
    handleChangePeriods,
    beforeChangePeriodsState,
    changePeriodsList,
    mountPeriodItems,
    generatePeriodVirtualId
}

export default periodsFunctions;